import React from "react";
import { useParams } from "react-router-dom";

import Page from "../../components/Page";
import RoleForm from "../../components/sections/role/RoleForm";

const Role = () => {
  const { id } = useParams();
  const title = id ? "Edit role" : "Add role";

  const breadcrumb = [
    {
      path: "/",
      breadcrumbName: "Home",
    },
    {
      path: "/roles",
      breadcrumbName: "Roles",
    },
    {
      path: "",
      breadcrumbName: title,
    },
  ];
  return (
    <>
      <Page title={title} breadcrumb={breadcrumb}>
        <div className="page-container">
          <div className="page-padding-leftRight page-padding-topBottom">
            <RoleForm />
          </div>
        </div>
      </Page>
    </>
  );
};

export default Role;
